import { getAppContext } from '~/lib/AppContext';
import { isProblemDetails } from './ErrorHelper';
import { LoginRoute } from './RouteHelper';
import { logoutZendeskMessenger } from './ZendeskHelper';

const loggedOutKey = 'panel.loggedOut';

/** Leave a one-off flag for the login page to say the customer has been logged out. */
export function markLoggedOut(): void {
    try {
        sessionStorage.setItem(loggedOutKey, '1');
    } catch {
        // Storage is unavailable (blocked site data); the login page just shows no notice.
    }
}

/** Whether `markLoggedOut` left a flag, clearing it so the notice shows once. */
export function consumeLoggedOut(): boolean {
    try {
        const loggedOut = sessionStorage.getItem(loggedOutKey) !== null;
        sessionStorage.removeItem(loggedOutKey);
        return loggedOut;
    } catch {
        return false;
    }
}

/**
 * End the customer's panel and Zendesk Messenger sessions, then load the login page afresh, which drops
 * every in-memory store holding their data. Throws, without navigating, if the logout call fails.
 */
export async function logOut(): Promise<void> {
    // Best effort: Messenger may not have loaded yet, so the login page repeats this.
    logoutZendeskMessenger();

    try {
        await getAppContext().siteApiClient.logout();
    } catch (error) {
        // The endpoint answers a logged-out caller with 204; a 401 would mean the same.
        if (!isProblemDetails(error) || error.status !== 401) throw error;
    }

    markLoggedOut();
    // Outside the /logout page, so a full page load; replacing keeps /logout out of the back history.
    getAppContext().navigate(LoginRoute, true);
}
